import { FieldParser, isNullOrUndefined, safeISODateConversion, timeToMilliseconds } from "../../_common/useGetExportData/parser/_core";

export const dateOnlyParser: FieldParser<string> = (value) => {
    const isoDate = safeISODateConversion(value);
    return isoDate ? isoDate.split('T')[0] : null;
};


export const timeParser: FieldParser<string> = (value) => {
    const isoDate = safeISODateConversion(value);
    return isoDate?.includes('T') ? isoDate.split('T')[1] : null;
};

export const durationParser: FieldParser<number> = (value) => {
    if (isNullOrUndefined(value)) return null;
    try {
        const date = new Date(String(value));
        return Number.isNaN(date.getTime()) ? null : timeToMilliseconds(date) / 1000;
    } catch {
        return null;
    }
};